import { render, staticRenderFns } from "./MsOrderList.vue?vue&type=template&id=62305e88&scoped=true&"
import script from "./MsOrderList.vue?vue&type=script&lang=js&"
export * from "./MsOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62305e88",
  null
  
)

export default component.exports